'use strict';

module.exports = {
    'en-us': {
        items: 'items',
        item: 'item'
    },
    'zh-cn': {
        items: '项',
        item: '项'
    },
    'zh-tw': {
        items: '項',
        item: '項'
    }
};


//////////////////
// WEBPACK FOOTER
// ./packages/bone-web-ui@1/node_modules/_@bone_bone-web-ui@1.0.7@@bone/bone-web-ui/lib/_components/@alife/next-transfer/lib/locale/index.js
// module id = 1948
// module chunks = 2